
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators'
import store from '../../index'

export interface cityInfoTypes {
  areaId?: number;
  areaName?: string;
  areaEngName?: string;
  letter?: string
}

interface cityInfoType {
  cityInfo: cityInfoTypes
}

@Module({
  name: 'City',
  dynamic: true,
  store
})
export default class City extends VuexModule implements cityInfoType {
  cityInfo: cityInfoTypes = {
    areaId: NaN
  }

  @Mutation
  SET_CITY_INFO (cityInfo?: cityInfoTypes): void {
    if (cityInfo) {
      this.cityInfo = cityInfo
    }
  }
}

export const CityStore = getModule(City)

CityStore.SET_CITY_INFO()
